module.exports = __webpack_public_path__ + "img/ilusTunelera.82c360c2.jpg";